import { FC } from "react";

import Image from "next/legacy/image";
import isAfter from "date-fns/isAfter";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { Tier } from "sections/christmasPage/Tier.interface";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card";
import CustomButton from "components/CustomButton";
import CustomLink from "components/CustomLink";

import { PAYMENT_TOKENS } from "enums/paymentTokens";

import { EXTERNAL_ROUTES } from "config/routes";

import { TIERS } from "services/gifts/Tiers";

import styles from "./styles";

const getChests = (): Tier[] => {
  const chests = [
    {
      title: "UNIQ Christmas Chest",
      description:
        "Mysterious Uniqly Christmas Chest with secret treasure inside. Grab it and check what we have prepared for you!",
      imagePath: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/christmas-chest.gif`,
      rewards: () => <>A mysterious premium gifts from Uniqly</>,
      requirements:
        "333 UNIQ payment, one purchase per network, available on Ethereum and Polygon.",
      button: "buy",
      price: "333",
      type: TIERS.CHRISTMAS_CHEST,
      paymentToken: PAYMENT_TOKENS.UNIQ,
    },
    {
      title: "Genesis Christmas Chest",
      description:
        "Hold Uniqly Genesis Collection on your wallet to get one of unrolled rewards from Uniqly Vault and additional NFTs backed by physical items and metaverse wearables.",
      imagePath: `${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/genesis-chest.gif`,
      rewards: () => {
        return (
          <>
            One from a few{" "}
            <CustomLink
              target="_blank"
              rel="noopener noreferrer"
              href={EXTERNAL_ROUTES.UNIQLY_VAULT}
            >
              Uniqly Vault
            </CustomLink>{" "}
            NFTs or various rewards available in other Presents.
          </>
        );
      },
      requirements:
        "Hold Uniqly Genesis Physical Collection, one wallet can claim only one Uniqly Genesis Chest.",
      button: "claim",
      type: TIERS.GENESIS_CHEST,
    },
  ];
  return chests;
};

const Tiers: FC = () => {
  const chests = getChests();

  return (
    <GridContainer
      spacing={4}
      sx={{ mt: { xs: 5, md: 12 } }}
      justifyContent="center"
    >
      {chests.map((chest, key) => (
        <GridItem
          key={`chest-${key}`}
          xs={12}
          md={12}
          lg={6}
          position="relative"
          sx={{ mt: { xs: 9, lg: 5 } }}
        >
          <Card sx={styles.card}>
            <Box
              display="flex"
              width="100%"
              sx={{
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Box
                display="flex"
                flex={1}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Image src={chest.imagePath} width={204} height={214} />
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                flex={2}
                sx={{ mt: { xs: 2, md: 0 } }}
              >
                <Typography variant="h3" component="h3">
                  {chest.title}
                </Typography>
                <Typography variant="subtitle1" mt={2}>
                  {chest.description}
                </Typography>
                {chest.requirements && (
                  <Typography variant="subtitle1" mt={2}>
                    <>
                      <strong>Requirements: </strong>
                      {chest.requirements}
                    </>
                  </Typography>
                )}
                <Typography variant="subtitle1" mt={2}>
                  <strong>Rewards pool: </strong>
                  {chest.rewards()}
                </Typography>
              </Box>
            </Box>
          </Card>
          <CustomButton sx={styles.button} disableRipple disabled={true}>
            <Typography variant="h3" fontWeight="bold" sx={styles.buttonText}>
              {chest.button}
            </Typography>
            {chest.price && (
              <Typography variant="subtitle1" sx={styles.buttonText}>
                Price: {chest.price} {PAYMENT_TOKENS.UNIQ}
              </Typography>
            )}
          </CustomButton>
        </GridItem>
      ))}
    </GridContainer>
  );
};

export default Tiers;
